import React from 'react';
import { Link } from 'react-router-dom';
import { CalculatorIcon, ArrowRightIcon, BuildingIcon, PieChartIcon } from 'lucide-react';
export function ToolsSection() {
  return <section id="tools" className="py-24 bg-[#f8f9fb] dark:bg-[#0f1629] border-t border-slate-100 dark:border-white/5 transition-colors duration-300 relative z-10" data-id="element-1399">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1400">
        <div className="bg-white dark:bg-[#1a2035] border border-slate-200 dark:border-white/10 rounded-3xl p-8 md:p-12 shadow-sm dark:shadow-none transition-colors duration-300 relative overflow-hidden" data-id="element-1401">
          {/* Background Elements */}
          <div className="absolute top-0 right-0 p-8 opacity-5" data-id="element-1402">
            <CalculatorIcon className="w-64 h-64" data-id="element-1403" />
          </div>

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-1404">
            <div data-id="element-1405">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none mb-6" data-id="element-1406">
                <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-1407">
                  Interactive Tools
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-4" data-id="element-1408">
                Understand Your Position
              </h2>
              <p className="text-lg text-slate-500 dark:text-slate-400 mb-8" data-id="element-1409">
                Whether you're modelling portfolio growth, checking your
                borrowing capacity, or planning your budget — our suite of
                interactive tools helps you see exactly where you stand.
              </p>

              <Link to="/tools" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-accent-500 to-primary-500 text-white font-semibold hover:shadow-[0_0_20px_rgba(20,184,166,0.3)] transition-all group" data-id="element-1410">
                Explore Interactive Tools
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1411" />
              </Link>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-1412">
              <div className="bg-slate-50 dark:bg-[#0f1629] p-6 rounded-2xl border border-slate-200 dark:border-white/10 flex flex-col items-center justify-center text-center gap-3" data-id="element-1413">
                <div className="w-12 h-12 rounded-full bg-primary-100 dark:bg-primary-500/20 flex items-center justify-center text-primary-600 dark:text-primary-400" data-id="element-1414">
                  <BuildingIcon className="w-6 h-6" data-id="element-1415" />
                </div>
                <span className="font-medium text-slate-900 dark:text-white" data-id="element-1416">
                  Portfolio Pulse Check
                </span>
              </div>
              <div className="bg-slate-50 dark:bg-[#0f1629] p-6 rounded-2xl border border-slate-200 dark:border-white/10 flex flex-col items-center justify-center text-center gap-3" data-id="element-1417">
                <div className="w-12 h-12 rounded-full bg-accent-100 dark:bg-accent-500/20 flex items-center justify-center text-accent-600 dark:text-accent-400" data-id="element-1418">
                  <CalculatorIcon className="w-6 h-6" data-id="element-1419" />
                </div>
                <span className="font-medium text-slate-900 dark:text-white" data-id="element-1420">
                  Loan Calculator
                </span>
              </div>
              <div className="bg-slate-50 dark:bg-[#0f1629] p-6 rounded-2xl border border-slate-200 dark:border-white/10 flex flex-col items-center justify-center text-center gap-3 col-span-2" data-id="element-1421">
                <div className="w-12 h-12 rounded-full bg-emerald-100 dark:bg-emerald-500/20 flex items-center justify-center text-emerald-600 dark:text-emerald-400" data-id="element-1422">
                  <PieChartIcon className="w-6 h-6" data-id="element-1423" />
                </div>
                <span className="font-medium text-slate-900 dark:text-white" data-id="element-1424">
                  Budget & Savings Planners
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}